import React from 'react'

function TenderTextDN() {
  return (
    <embed src="\pdfs\EAT1.3.3_BA-V-DN150_Adjustable_floor_outlet_kr.pdf" width="100%" height="2100px" />
  )
}

export default TenderTextDN